module.exports = __webpack_public_path__ + "img/6_62.f29b0293.png";